
function initModalDataToggle(parent) {
	if (parent == null) parent = $("body");

	$("[data-toggle=modal]", parent).click(function (e) {
		e.preventDefault();
		e.stopPropagation();

		var url = $(this).attr('href');

		$(".modal").modal('hide');
		$(".modal").remove();

		if (url == "") {
			swal({
				text: 'Ссылка для модального окна пустая',
				title: 'Не удалось открыть',
				type: 'error',
				showCancelButton: false,
				showConfirmButton: true,
				confirmButtonText: "Закрыть"
			});
		} else if (url.indexOf('#') == 0) {
			$(url).modal('open');
		} else {
			var dialog = $('<div class="modal fade" role="dialog"></div>');
			var spinner = $('<div class="modal-spinner modal fade" style="display: block; opacity: 1;"><div class="sk-spinner sk-spinner-white sk-spinner-three-bounce" style="margin-top:20px;"><div class="sk-bounce1"></div><div class="sk-bounce2"></div><div class="sk-bounce3"></div></div></div>');
			dialog
				.on("hide.bs.modal", function () {
					dialog.attr("modal-ajax-cancel", true);
				})
				.modal();

			$.get(url)
			.done(function (data) {
				if (dialog.is("[modal-ajax-cancel]")) return;

				var wrapper = $('<div class="fade"></div>');
				wrapper.html(data);
				dialog.html(wrapper);

				setTimeout(function () {
					wrapper.addClass("in");
					$('input:text:visible:first', dialog).focus();

					initForDialog($('.modal'));
				}, 200);
			})
			.fail(function () {
				if (dialog.is("[modal-ajax-cancel]")) return;

				dialog.modal('hide');

				swal({
					title: "Не удалось открыть окно",
					type: "error"
				});
			});

			setTimeout(function () {
				if (dialog.html() == "") dialog.html(spinner);
			}, 500)
			
		}
	});
}

$(function () {
	initModalDataToggle();
})